import { gql, useMutation } from '@apollo/client'
import {
  MutationUserRemoveArgs,
  MutationUserRemovePayload,
} from 'src/generated'

const MUTATION_USER_REMOVE = gql`
  mutation UserRemove($input: MutationUserRemoveInput!) {
    userRemove(input: $input) {
      deletedCount
    }
  }
`

const useUserRemoveMutation = () => {
  return useMutation<
    { userRemove: MutationUserRemovePayload },
    MutationUserRemoveArgs
  >(MUTATION_USER_REMOVE)
}

export default useUserRemoveMutation
